import { Route, Routes } from '@angular/router';
import { BaseRoutingFactory } from './base-routing.factory';
import { AIComponent } from '../features/chat/forms/ai/ai.component';

export class ChatRoutingFactory extends BaseRoutingFactory {
    private readonly coreChatRoute: Routes = [
        {
            path: '',
            component: AIComponent,
            resolve: {
                
            },
        },
    ];

    public create(): Routes {
        const coreRoute = this.coreRoute;

        // How to add a custom form:
        // Extend from this factory and provide it in the app module
        // Override the create method and call the registerCustomForm method
        // For example:
        
        // this.registerChild(coreRoute, {
        //     path: 'customized-project-data/:abschnittid',
        //     component: CustomizedProjectDataProcessStepComponent,
        //     canDeactivate: [],
        //     resolve: {
        //         projectData: GetAnfrageProjectDataResolver,
        //     },
        // });

        return coreRoute;
    }

    protected get coreRoute(): Routes {
        return this.coreChatRoute;
    }

    protected registerChild(coreRoute: Routes, route: Route): void {
        const formRoutes = coreRoute![2].children!;
        const foundIndex = formRoutes?.findIndex(
            (formRoute) => formRoute.path === route.path
        );
        if (foundIndex >= 0) {
            formRoutes[foundIndex] = route;
        } else {
            coreRoute![2].children!.push(route);
        }
    }
}
